import { MODULE } from "./add-product-to-kit-inline.actionTypes";

const getInstance = (state, instanceId) =>
  state.getIn([MODULE, "instances", instanceId]) || {
    isFetchingStatus: "IDLE",
    products: [],
    isSearchResultOpen: false,
    search: "",
  };

export const isFetchingStatus = (state, instanceId) =>
  getInstance(state, instanceId).isFetchingStatus;

export const getProducts = (state, instanceId) => getInstance(state, instanceId).products;

export const isSearchResultOpen = (state, instanceId) =>
  getInstance(state, instanceId).isSearchResultOpen;

export const getSearch = (state, instanceId) => getInstance(state, instanceId).search;

export const getAllInstanceIds = (state) => {
  const instances = state.getIn([MODULE, "instances"]);
  return instances ? Object.keys(instances) : [];
};
